import { L2_PATHS } from 'Deer/constants/routes';
import { OrganizationSettingsIntent } from 'Deer/intent/Settings/Platform/OrganizationSettingsIntent';
import { PlatformIntentDropdown } from 'Deer/intent/Settings/Platform/PlatformIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';

const ORGANIZATION_BREADCRUMBS = {
  items: [
    {
      label: 'Company',
      to: L2_PATHS.company.overview,
    },
  ],
  page: {
    label: 'Platform Settings',
    to: '',
  },
};

export const OrganizationSettings = () => (
  <Layout Filters={<PlatformIntentDropdown breadcrumbs={ORGANIZATION_BREADCRUMBS} />}>
    <OrganizationSettingsIntent />
  </Layout>
);
